import colors from "@streeteasy/design-system/deprecated/colors";

export const baseStyles = `
  font-family: "Source Sans Pro", Helvetica, Arial, Geneva, sans-serif;
  -webkit-font-smoothing: antialiased;
  margin: 0;
`;

export const TextTypes = {
  default: {
    fontSize: "16px",
    lineHeight: "1.5"
  },
  sm: {
    fontSize: "14px",
    lineHeight: "1.6"
  },
  disclaimer: {
    color: colors.wolfGrey,
    fontSize: "12px",
    lineHeight: "1.3"
  }
};

export const TitleTypes = {
  primaryLg: {
    fontSize: "40px"
  },
  primaryMd: {
    fontSize: "32px"
  },
  primarySm: {
    fontSize: "28px"
  },
  secondaryLg: {
    fontSize: "22px",
    lineHeight: "1.5"
  },
  secondaryMd: {
    fontSize: "18px",
    lineHeight: "1.4"
  },
  secondarySm: {
    fontSize: "16px",
    lineHeight: "1.5"
  },
  secondary: {
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "1.5"
  },
  secondarySmCaps: {
    fontSize: "12px",
    fontWeight: "bold",
    lineHeight: "1.3",
    textTransform: "uppercase"
  }
};
